export interface SystemSettings {
  id?: string;
  pin: string;
  mainNotificationRecipient: string;
  additionalNotificationsRecipients: string[];
  securityInfoRecipients: string[] | null;
  selfRegistrationActive: boolean;
  promotionalBannerMessage: string;
  promotionalBannerIsActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}
